<nav class="ui-breadcrumb" [attr.aria-label]="ariaLabel()">
  <ol class="ui-breadcrumb__list">
    @for (item of allItems(); track item.id; let i = $index) {

      @if (i > 0) {
        <li class="ui-breadcrumb__sep" aria-hidden="true">
          <svg
            class="ui-breadcrumb__sep-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M9 18l6-6-6-6" />
          </svg>
        </li>
      }

      <li class="ui-breadcrumb__item">
        @if (isLast(i)) {
          <!-- Último ítem: no navegable -->
          <span
            class="ui-breadcrumb__current"
            [class.ui-breadcrumb__current--icon-only]="!!item.iconSrc && !item.label"
            aria-current="page"
          >
            @if (item.iconSrc) {
              <img
                class="ui-breadcrumb__icon"
                [src]="item.iconSrc"
                alt=""
                aria-hidden="true"
                width="16"
                height="16"
              />
            }
            @if (item.label) {
              <span>{{ item.label }}</span>
            }
          </span>
        } @else if (item.routerLink) {
          <a
            class="ui-breadcrumb__link"
            [class.ui-breadcrumb__link--icon-only]="!!item.iconSrc && !item.label"
            [class.ui-breadcrumb__link--disabled]="item.disabled"
            [routerLink]="item.disabled ? null : item.routerLink"
            [attr.aria-disabled]="item.disabled ? 'true' : null"
            [attr.tabindex]="item.disabled ? -1 : 0"
            (click)="onItemClick(item, $event)"
          >
            @if (item.iconSrc) {
              <img
                class="ui-breadcrumb__icon"
                [src]="item.iconSrc"
                [attr.alt]="item.label || 'Inicio'"
                width="16"
                height="16"
              />
            }
            @if (item.label) {
              <span>{{ item.label }}</span>
            }
          </a>
        } @else if (item.href) {
          <a
            class="ui-breadcrumb__link"
            [class.ui-breadcrumb__link--icon-only]="!!item.iconSrc && !item.label"
            [class.ui-breadcrumb__link--disabled]="item.disabled"
            [href]="item.href"
            [attr.aria-disabled]="item.disabled ? 'true' : null"
            [attr.tabindex]="item.disabled ? -1 : 0"
            (click)="onItemClick(item, $event)"
          >
            @if (item.iconSrc) {
              <img
                class="ui-breadcrumb__icon"
                [src]="item.iconSrc"
                [attr.alt]="item.label || 'Inicio'"
                width="16"
                height="16"
              />
            }
            @if (item.label) {
              <span>{{ item.label }}</span>
            }
          </a>
        } @else {
          <!-- Sin enlace: ítem interactivo sin navegación (no último) -->
          <span
            class="ui-breadcrumb__link ui-breadcrumb__link--plain"
            [class.ui-breadcrumb__link--disabled]="item.disabled"
            [attr.role]="item.disabled ? null : 'button'"
            [attr.tabindex]="item.disabled ? null : 0"
            (click)="onItemClick(item, $event)"
          >
            @if (item.iconSrc) {
              <img
                class="ui-breadcrumb__icon"
                [src]="item.iconSrc"
                alt=""
                aria-hidden="true"
                width="16"
                height="16"
              />
            }
            @if (item.label) {
              <span>{{ item.label }}</span>
            }
          </span>
        }
      </li>
    }
  </ol>
</nav>
